export const VideoCallRequestType = Object.freeze({
    startVideoCall: 'StartVideoCall',
    videoCallStarted: 'VideoCallStarted',
    enteredToVideoCall: 'EnteredToVideoCall',
    leaveToVideoCall: 'LeavedToVideoCall',
    endVideoCall: 'EndVideoCall',
})